import "firebase/auth"
import { useState } from "react"
import { useAuth } from "reactfire"
import { Button, Center, Grid, Input, Text } from "@chakra-ui/react"

import Logo from "../Common/AppLogo"
import FormField from "../Common/FormField"

const SignInForm = () => {
  const auth = useAuth()
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [invalidCredentials, setInvalidCredentials] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const signIn = (e) => {
    e.preventDefault()
    setIsLoading(true)
    setInvalidCredentials(false)
    auth.signInWithEmailAndPassword(email, password).catch((error) => {
      setIsLoading(false)
      setInvalidCredentials(true)
    })
  }

  return (
    <Center p={16}>
      <Grid as="form" gap={4} p={4} onSubmit={signIn}>
        <Logo primaryColor="#2C7A7B" secondaryColor="#234E52" />
        <Grid gap={4} my={4}>
          <FormField label="Email" isRequired>
            <Input
              variant="filled"
              size="lg"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </FormField>
          <FormField label="Password" isRequired>
            <Input
              type="password"
              variant="filled"
              size="lg"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </FormField>
        </Grid>
        <Button
          type="submit"
          colorScheme="teal"
          size="lg"
          isLoading={isLoading}
        >
          ACCEDI
        </Button>
        {invalidCredentials && (
          <Text fontSize="md" color="red.500" align="center">
            Credenziali errate
          </Text>
        )}
      </Grid>
    </Center>
  )
}

export default SignInForm
